import { render, staticRenderFns } from "./GeneralLayout.vue?vue&type=template&id=22495f4a&scoped=true"
import script from "./GeneralLayout.vue?vue&type=script&lang=ts"
export * from "./GeneralLayout.vue?vue&type=script&lang=ts"
import style0 from "./GeneralLayout.vue?vue&type=style&index=0&id=22495f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22495f4a",
  null
  
)

export default component.exports